import { combineReducers } from '@reduxjs/toolkit';

import { reducer as fileUploadReducer } from 'src/slices/files';
import { reducer as schedulingReducer } from 'src/slices/scheduling';

import { reducer as conflictsReducer } from 'src/store/slices/conflicts';
import { reducer as debriefReducer } from 'src/store/slices/debrief';
import { reducer as jobStagePlanConfigReducer } from 'src/store/slices/job-stage-plan-config';
import { reducer as scheduleCommunicationsReducer } from 'src/store/slices/schedule-communications';
import { reducer as scheduleFiltersReducer } from 'src/store/slices/schedule-filters';
import { reducer as scheduleUpdateReducer } from 'src/store/slices/schedule-update';
import { reducer as schedulesReducer } from 'src/store/slices/schedules';

const rootReducer = combineReducers({
  conflicts: conflictsReducer,
  debrief: debriefReducer,
  fileUpload: fileUploadReducer,
  jobStagePlanConfig: jobStagePlanConfigReducer,
  scheduleCommunications: scheduleCommunicationsReducer,
  scheduleFilters: scheduleFiltersReducer,
  schedules: schedulesReducer,
  scheduleUpdate: scheduleUpdateReducer,
  scheduling: schedulingReducer,
});

export default rootReducer;
